import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import api from '../services/api'
import SelecaoColaboradores, { selecaoColaboradoresVazia, SelecaoColaboradoresValor } from '../components/SelecaoColaboradores'

const MESES = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']

// responseType 'blob' faz o axios devolver o corpo como Blob mesmo num erro (400/404) —
// precisa ler como texto pra achar a mensagem JSON que o backend mandou.
async function extrairMensagemDeErro(e: any): Promise<string> {
  const padrao = 'Erro ao gerar o PDF em lote.'
  if (e.response?.data instanceof Blob) {
    try {
      const texto = await e.response.data.text()
      return JSON.parse(texto).error ?? padrao
    } catch { /* corpo não era JSON, mantém mensagem genérica */ }
  }
  return e.response?.data?.error ?? padrao
}

export default function ImprimirFichasLote() {
  const navigate = useNavigate()
  const [selecao, setSelecao] = useState<SelecaoColaboradoresValor>(selecaoColaboradoresVazia())
  const [ano, setAno] = useState(new Date().getFullYear())
  const [mes, setMes] = useState(new Date().getMonth() + 1)
  const [erro, setErro] = useState('')
  const [imprimindo, setImprimindo] = useState(false)

  async function imprimir() {
    if (selecao.modo === 'individual' && selecao.colaboradoresIndividuais.length === 0) { setErro('Selecione ao menos um colaborador.'); return }
    if (selecao.modo === 'categoria' && selecao.catcat.length === 0) { setErro('Selecione ao menos uma categoria de cargo.'); return }

    setImprimindo(true)
    setErro('')
    try {
      const params: Record<string, string | number> = { ano, mes, modo: selecao.modo }
      if (selecao.modo === 'categoria') params.catcat = selecao.catcat.join(',')
      if (selecao.modo === 'individual') params.colaboradores = selecao.colaboradoresIndividuais.map(c => c.motcod).join(',')
      if (selecao.excluidos.length > 0) params.excluidos = selecao.excluidos.join(',')

      const r = await api.get('/cartao-ponto/fichas/pdf-lote', { params, responseType: 'blob' })
      const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
      window.open(url, '_blank')

      const resumoHeader = r.headers['x-resumo-impressao']
      if (resumoHeader) {
        const resumo = JSON.parse(decodeURIComponent(resumoHeader))
        if (resumo.semFicha?.length > 0) {
          alert(
            `${resumo.impressas} ficha(s) impressa(s).\n` +
            `${resumo.semFicha.length} colaborador(es) sem ficha nesse período: ${resumo.semFicha.join(', ')}`,
          )
        }
      }
    } catch (e: any) {
      setErro(await extrairMensagemDeErro(e))
    } finally {
      setImprimindo(false)
    }
  }

  return (
    <div style={{ maxWidth: 900 }}>
      <div className="card">
        <h3 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: '0.4rem' }}>Imprimir Fichas em Lote</h3>
        <p style={{ color: '#6b7280', fontSize: '0.85rem', marginTop: 0, marginBottom: '1rem' }}>
          Gera um único PDF com o Extrato de Horas de cada colaborador selecionado (uma ficha por página), no ano/mês informado.
          Funciona tanto com fichas abertas quanto fechadas; colaboradores sem ficha nesse período são ignorados.
        </p>

        <SelecaoColaboradores valor={selecao} onChange={setSelecao} />

        <div className="form-grid" style={{ gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginTop: '1.2rem' }}>
          <div className="field">
            <label>Ano da ficha *</label>
            <input type="number" value={ano} onChange={e => setAno(Number(e.target.value))} />
          </div>
          <div className="field">
            <label>Mês da ficha *</label>
            <select value={mes} onChange={e => setMes(Number(e.target.value))}>
              {MESES.map((m, i) => <option key={i + 1} value={i + 1}>{m}</option>)}
            </select>
          </div>
        </div>

        {erro && <div style={{ color: '#b91c1c', fontSize: '0.85rem', marginTop: '0.5rem' }}>{erro}</div>}

        <div style={{ display: 'flex', gap: 8, marginTop: '1rem' }}>
          <button className="btn btn-primary" onClick={imprimir} disabled={imprimindo}>
            {imprimindo ? 'Gerando...' : '🖨️ Imprimir'}
          </button>
          <button className="btn btn-outline" onClick={() => navigate('/funcionarios/ficha-ponto')}>Voltar</button>
        </div>
      </div>
    </div>
  )
}
